import { render } from "./CanadaHub.vue?vue&type=template&id=8d876814"
import script from "./CanadaHub.vue?vue&type=script&lang=js"
export * from "./CanadaHub.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__